import React from 'react';
import { get } from 'lodash'
import { withFilterCars } from './containers/containerFilterCars'

import DropDownSelect from './items/contols/dropDownSelect'
import CountOnPageDropdownMenu from './countOnPageDropdownMenu'
import { getCountOnPageTitle } from './static.countOnPage'

import styles from './controlCountOnPage.module.scss'

const handleChangeSize = (props, value) => {
  const { onHandleChangeStore } = props

  onHandleChangeStore(['page', 'count'], [1, value])
}

const ControlCountOnPage = props => {
  const { filterCarsListItems } = props
  
  return null; 

  return (
    <div className={styles.controlCountOnPage}>
      <span className={styles.title}>Показывать по:</span>

      <DropDownSelect
        buttonTitle={getCountOnPageTitle(get(filterCarsListItems, ["count"], 0))}
        content={<CountOnPageDropdownMenu handleChooseCountOnPage={handleChangeSize.bind(this, props)} />}
      />
    </div>
  )
}

export default withFilterCars(React.memo(ControlCountOnPage))
